import {combineReducers} from 'redux'
import {routinePromiseWatcherSaga} from 'redux-saga-routines'
import {all, fork} from '@redux-saga/core/effects'

// reducers
import authReducer from 'features/auth/ducks/reducer'
import bpReducer from 'features/bpList/ducks/reducer'
import bpDetailsReducer from 'features/bpDetails/ducks/reducer'
import bpCreationReducer from 'features/createBp/ducks/reducer'
import billingListReducer from 'features/billingList/ducks/reducer'
import notificationsReducer from 'features/notifications/ducks/reducer'
import cartReducer from 'features/cart/ducks/reducer'
import accessRequestReducer from 'features/AccessRequest/ducks/reducer'
import dictionariesReducer from 'ducks/dictionaries/reducer'
import loaderReducer from 'ducks/loaderReducer'
import analyticsReducer from 'features/analytics/ducks/reducer'
import dashboardReducer from 'features/dashboard/ducks/reducer'
import unitsReducer from 'ducks/units/reducer'
import filesReducer from 'ducks/files/reducer'
import sessionReducer from 'features/session/ducks/reducer'
import guruInsightReducer from 'ducks/guruInsight/reducer'
import reportingReducer from 'ducks/reporting/reducer'
import inboxReducer from 'features/inbox/ducks/reducer'

// sagas
import {authSagas} from 'features/auth/ducks/actions'
import {bpSagas} from 'features/bpList/ducks/actions'
import {bpCreationSagas} from 'features/createBp/ducks/actions'
import {billingListSagas} from 'features/billingList/ducks/actions'
import {notificationSagas} from 'features/notifications/ducks/actions'
import {accessControlSagas} from 'features/accessControl/ducks/actions'
import {requestAccessSagas} from 'features/AccessRequest/ducks/actions'
import {dictionariesSagas} from 'ducks/dictionaries/actions'
import {analyticsSagas} from 'features/analytics/ducks/actions'
import {unitSagas} from 'ducks/units/actions'
import {filesSagas} from 'ducks/files/actions'
import {bpDetailsSagas} from 'features/bpDetails/ducks/actions'
import {dashboardSagas} from 'features/dashboard/ducks/actions'
import {cartSagas} from 'features/cart/ducks/actions'
import {sessionSagas} from "../features/session/ducks/actions";
import {guruInsightSaga} from 'ducks/guruInsight/actions';
import {reportingSagas} from 'ducks/reporting/actions';
import {inboxSagas} from 'features/inbox/ducks/actions'
import tutorialsReducer from "../features/tutorials/ducks/reducer";
import {tutorialsSagas} from "../features/tutorials/ducks/actions";
import {whatsNewSagas} from "../features/whatsNew/ducks/actions";
import whatsNewReducer from "../features/whatsNew/ducks/reducer";
import taskManagementReducer from 'features/taskManagement/ducks/reducer';
import {taskManagementSagas} from 'features/taskManagement/ducks/actions';
import offlineReducer from 'ducks/offline/reducer';
import {offlineSagas} from 'ducks/offline/actions';
import guruChatReducer from 'ducks/guruChat/reducer';
import {guruChatSaga} from 'ducks/guruChat/actions';
import portfolioReducer from 'ducks/portfolio/reducer';
import {portfolioSaga} from 'ducks/portfolio/actions';
import portfolioDocumentsReducer from 'ducks/portfolioDocuments/reducer';
import {portfolioDocumentsSaga} from 'ducks/portfolioDocuments/actions';
import {reducer as actionsReducer} from 'features/actions/ducks';
import actionsSagas from 'features/actions/ducks/sagas';
import {reducer as incidentsReducer} from 'features/incidents/ducks';
import incidentsSagas from 'features/incidents/ducks/sagas';
import buildingWikiReducer from 'ducks/buildingWiki/reducer';
import watchBuildingWiki from 'ducks/buildingWiki/actions';
import guruRecommendationsReducer from 'ducks/guruRecommendations/reducer';
import { guruRecommendationsSaga } from 'ducks/guruRecommendations/actions';
import guruWidgetReducer from 'ducks/guruWidget/reducer';
import complianceReducer from 'features/compliance/ducks/reducer';
import {complianceSagas} from 'features/compliance/ducks/actions';
import estatesReducer from 'ducks/estates/reducer';
import {estatesSagas} from 'ducks/estates/actions';
import estateDocumentsReducer from 'ducks/estateDocuments/reducer';
import {estateDocumentsSagas} from 'ducks/estateDocuments/actions';

// reducer
const appReducer = combineReducers({
  files: filesReducer,
  bpDetails: bpDetailsReducer,
  auth: authReducer,
  bp: bpReducer,
  bpCreation: bpCreationReducer,
  billingList: billingListReducer,
  notifications: notificationsReducer,
  accessRequest: accessRequestReducer,
  dictionaries: dictionariesReducer,
  loader: loaderReducer,
  analytics: analyticsReducer,
  units: unitsReducer,
  dashboard: dashboardReducer,
  cart: cartReducer,
  session: sessionReducer,
  guruInsight: guruInsightReducer,
  reporting: reportingReducer,
  inbox: inboxReducer,
  tutorials: tutorialsReducer,
  whatsNew: whatsNewReducer,
  taskManagement: taskManagementReducer,
  offline: offlineReducer,
  guruChat: guruChatReducer,
  portfolio: portfolioReducer,
  portfolioDocuments: portfolioDocumentsReducer,
  actions: actionsReducer,
  incidents: incidentsReducer,
  buildingWiki: buildingWikiReducer,
  guruRecommendations: guruRecommendationsReducer,
  guruWidget: guruWidgetReducer,
  compliance: complianceReducer,
  estates: estatesReducer,
  estateDocuments: estateDocumentsReducer,
})

export default appReducer

export function* rootSaga() {
  yield all([
    ...authSagas,
    ...bpSagas,
    ...bpDetailsSagas,
    ...bpCreationSagas,
    ...billingListSagas,
    ...notificationSagas,
    ...accessControlSagas,
    ...requestAccessSagas,
    ...dictionariesSagas,
    ...analyticsSagas,
    ...unitSagas,
    ...filesSagas,
    ...dashboardSagas,
    ...cartSagas,
    ...sessionSagas,
    ...inboxSagas,
    ...reportingSagas,
    ...tutorialsSagas,
    ...whatsNewSagas,
    ...taskManagementSagas,
    ...offlineSagas,
    ...complianceSagas,
    ...estateDocumentsSagas,
    fork(guruInsightSaga),
    fork(guruChatSaga),
    fork(portfolioSaga),
    fork(portfolioDocumentsSaga),
    fork(actionsSagas),
    fork(incidentsSagas),
    fork(watchBuildingWiki),
    fork(guruRecommendationsSaga),
    fork(estatesSagas),
    fork(routinePromiseWatcherSaga)
  ])
}
